import React from "react";
import { Page } from "app";
import { Link, Redirect } from "react-router-dom";
import { reduxForm } from "redux-form";
import { SubmissionError } from "redux-form";
import { login, resetForm } from "app/auth/actions";
import { LOGIN } from "app/auth/constants";
import { connect } from "react-redux";
import * as fields from "app/auth/fields";
import { Form, FormError, SubmitButton } from "app/forms";
import styled from "styled-components";
import Helmet from "react-helmet";
import { Classes, Callout, Intent } from "@blueprintjs/core";
import { injectIntl, FormattedMessage } from "react-intl";
import { compose } from "recompose";

let LoginForm = props => {
  const { handleSubmit, submitting, valid, error, intl } = props;
  const className = Classes.LARGE;
  return (
    <Form className="pt-card pt-elevation-1" onSubmit={handleSubmit}>
      <fields.Email props={{ className }} />
      <fields.Password props={{ className, submitting }} />
      <FormError error={error} submitting={submitting} />
      <SubmitButton
        valid={valid}
        submitting={submitting}
        text={intl.formatMessage({ id: "app.login", defaultMessage: "Login" })}
        className="pt-large"
      />
    </Form>
  );
};

LoginForm = injectIntl(
  reduxForm({
    form: "loginForm"
  })(LoginForm)
);

const ResetBox = styled.div`
  text-align: right;
`;

class Login extends React.Component {
  componentDidMount() {
    // NOTE this is a bit of hack to deal with the persitet auth store
    // We want a clean state every time the form is visited
    this.props.resetForm();
  }

  handleSubmit = values => {
    // NOTE afaik the catch is never reached
    return this.props.login(values).catch(error => {
      if (error && error.type === LOGIN.ERROR) {
        throw new SubmissionError({ _error: error });
      }
      throw error;
    });
  };

  render() {
    const { from, showWarning } = this.props.location.state || {};
    const { loginFailedMsg, redirectToReferrer, intl } = this.props;
    const urlSearch = window.location.search;
    if (redirectToReferrer) {
      console.log("hi");
      return <Redirect to={((from && from.pathname) || "/") + urlSearch} />;
    }
    const title = intl.formatMessage({
      id: "app.login",
      defaultMessage: "Login"
    });
    return (
      <Page className="pt-ui-text-large pt-running-text">
        <Helmet title={title} />
        <h1>{title}</h1>
        {loginFailedMsg && (
          <Callout intent={Intent.WARNING} iconName="warning-sign">
            Login failed due: {loginFailedMsg}
          </Callout>
        )}
        {showWarning && (
          <Callout intent={Intent.WARNING} iconName="warning-sign">
            <FormattedMessage
              id="auth.loggedin.message"
              defaultMessage="You must be logged in to view the page at"
            />{" "}
            <code>{from.pathname}</code>.
          </Callout>
        )}
        <LoginForm onSubmit={this.handleSubmit} />
        <ResetBox>
          <Link to={"/reset" + urlSearch}>
            <FormattedMessage
              id="auth.resetmessage"
              defaultMessage="Click here to reset your password"
            />
          </Link>
        </ResetBox>
      </Page>
    );
  }
}

export default compose(
  connect(
    state => {
      return {
        loginFailedMsg: state.auth.loginFailedMsg,
        redirectToReferrer: state.auth.redirectToReferrer
      };
    },
    dispatch => ({
      login: values => dispatch(login(values)),
      resetForm: () => dispatch(resetForm())
    })
  ),
  injectIntl
)(Login);



// WEBPACK FOOTER //
// ./src/app/auth/Login.js